var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard"},[_c('div',{staticClass:"wizard-content"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{key:_vm.activeStepId},[_vm._t(_vm.activeStepId)],2)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }